import Customer from "../../domain/Customer/Customer";
import RegistrationCreationRequest from "../../domain/Registration/RegistrationCreationRequest";
import UserSessionService from "../UserSessionService";
import WsService from "../WsService";
import BankAccountCreationRequest from "../../domain/Registration/BankAccountCreationRequest";
import BankAccountRequestDTO from "../../domain/Registration/BankAccountRequestDTO";

const ENDPOINT_BASE = "/registrations/registration/";

export default class RegistrationService {

    static createRegistration(registrationCreationRequest, referralCode) {

        let jsonObj = RegistrationCreationRequest.toJson(registrationCreationRequest);
        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();

        let headers = {
            'registering-partner-id': registrationHeaders["registering-partner-id"],
            'registering-channel-id': registrationHeaders["registering-channel-id"],
            'referral-code': referralCode ? referralCode : ""
        };

        return WsService.postWithHeaders(ENDPOINT_BASE, jsonObj, 201, headers).then(
            response => {
                return new Customer(response);
            },
            response => {
                return response;
            });
    }


    static requestBankAccount(registrationId, bankAccountCreationRequest) {

        let jsonObj = BankAccountCreationRequest.toJson(bankAccountCreationRequest);
        let endpoint = ENDPOINT_BASE + "/" + registrationId + "/bank-account-request";

        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
        let headers = {
            'registering-partner-id': registrationHeaders["registering-partner-id"],
            'registering-channel-id': registrationHeaders["registering-channel-id"]
        };

        return WsService.postWithHeaders(endpoint, jsonObj, 200, headers).then(
            response => {
                return new BankAccountRequestDTO(response);
            },
            response => {
                return response;
            });
    }
}
